const state = {
    project:{
        number:'',
        name:'',
    },
};

const getters = {
    getProject: state => state.project,
};

const actions = {
    setProject: (store, payload) => store.commit("PROJECT_SET",payload),
    resetProject: (store) => store.commit("PROJECT_RESET"),
};

const mutations = {
    PROJECT_SET: (state, payload) => state.project = payload,
    PROJECT_RESET: (state) => state.project = {
        number:'',
        name:'',
    },
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
